module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/assessment_achievements/6_3762adcc0104b27df65274fd8c69a1c3.png";